<template>
  <div class="text_mobile_header_index_container">
    <p>Experiencias en gestión del cambio climático del sector agropecuario en Colombia</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.text_mobile_header_index_container {
  background-color: #3366cc;
}
.text_mobile_header_index_container > p {
  font-size: 30px;
  text-align: center;
  color: #fff;
  padding: 25px;
}
@media (min-width: 768px) {
  .text_mobile_header_index_container {
    display: none;
  }
}
</style>
